import { FC } from "react";
import { ButtonBase } from "./ButtonBase";

interface CtaButtonProps {
    text: string;
    onClick?: () => void;
    disabled?: boolean;
    href?: string;
    prefixIcon?: FC<{className?: string}>;
    suffixIcon?: FC<{className?: string}>;
    className?: string;
}

export const CtaButton: FC<CtaButtonProps> = (props) => {
    const ctaStyles = "bg-[var(--secondary)] text-white";

    return (
        <ButtonBase {...props} className={ctaStyles} />
    );
}